import getCoordinatesLngLatStringList from "@/helpers/getCoordinatesLngLatStringList";

export default {
  GET_ALL_COORDINATES: '/coordinates/all',
  GET_COORDINATE: (coordinateId) => `/coordinates/find/${ coordinateId }`,
  GET_COORDINATE_IMAGE: (coordinateId) => `/images/coordinate/${ coordinateId }`,
  GET_IMAGE: (imageId) => `/images/find/${ imageId }`,
  GET_IMAGE_BY_SRC_NUMBER: (srcNumber) => `/images/src_number/${ srcNumber }`,
  FILTER: '/filters',
  GET_TAGS: '/tags',
  GET_SETTINGS: '/settings',
  GET_ROUTES: '/itineraries',
  POST_VISITOR_DATA: "/visitorData",

  GET_MAPBOX_ROUTE: (coordinates, profile) => `https://api.mapbox.com/directions/v5/mapbox/${ profile }/${ getCoordinatesLngLatStringList(coordinates) }.json`
}
